import { createFileRoute } from "@tanstack/react-router";
import { RequiredAttachmentsField } from "@/features/attachment-requirements/required-attachments-field";
import { EntityTypeDetailsPanel } from "@/features/entity-types/components/entity-type-details-panel";
import { RequiredLocationField } from "@/features/entity-types/components/required-location-field";
import { useAppTranslation } from "@/hooks/use-app-translation";
import { isSystemTicketType } from "@/utils/ticket-type-detail/ticket-type-detail.utils";
import { useTicketTypeDrawerContext } from "@/utils/ticket-type-detail/ticket-type-drawer-context";
import { resolveTicketTypeDisplayIcon } from "@/utils/tickets";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/configuration/ticketTypes/$ticketTypeId/details",
)({
	component: AdminTicketTypeDetailsTab,
});

function AdminTicketTypeDetailsTab() {
	const { t } = useAppTranslation();
	const {
		ticketType,
		canEdit,
		persistDetails,
		locationRequired,
		persistLocationRequired,
	} = useTicketTypeDrawerContext();

	const sourceLabel = isSystemTicketType(ticketType)
		? t("admin.ticketTypes.table.source.system")
		: t("admin.ticketTypes.table.source.custom");

	return (
		<EntityTypeDetailsPanel
			labels={{
				name: t("admin.ticketTypes.drawer.details.fields.name"),
				icon: t("admin.ticketTypes.drawer.details.fields.icon"),
				source: t("admin.ticketTypes.drawer.details.fields.source"),
				lifecycle: t("admin.ticketTypes.drawer.details.fields.lifecycle"),
				id: t("admin.ticketTypes.drawer.details.fields.id"),
				description: t("admin.ticketTypes.drawer.details.fields.description"),
				nameRequired: t("admin.entityTypes.drawer.details.nameRequired"),
				saveFailed: t("admin.entityTypes.drawer.details.saveFailed"),
			}}
			name={ticketType.name}
			icon={ticketType.icon}
			description={ticketType.description}
			sourceLabel={sourceLabel}
			lifecycleLabel={ticketType.lifecycleName}
			showLifecycle
			id={ticketType.id}
			resolveIcon={(icon) =>
				resolveTicketTypeDisplayIcon(icon, ticketType.name)
			}
			iconEditable
			locationRequiredField={
				<RequiredLocationField
					value={locationRequired}
					canEdit={canEdit}
					onChange={persistLocationRequired}
				/>
			}
			attachmentsField={
				<RequiredAttachmentsField
					entityKind="ticket"
					typeId={ticketType.id}
					requirement={ticketType.attachmentRequirement}
				/>
			}
			canEdit={canEdit}
			onPersist={persistDetails}
			data-testid="tickettype-details-panel"
		/>
	);
}
